import { Flex } from 'antd'

import { TradeSessionStatus } from '../../../../pages/TradeSession/enums/TradeSessionStatus'
import { useTradeSessionStatusInfo } from '../../../../pages/TradeSession/hooks/useStatusInfo'

import { HomeApplyAnnouncementDetailButton } from './components/AnnouncementDetailButton'
import { HomeAuctionDetailButton } from './components/AuctionDetailButton'
import { HomePriceCompareApplyButton } from './components/PriceCompareApplyButton'
import { HomePriceCompareDetailButton } from './components/PriceCompareDetailButton'
import { HomeTradeSessionStatusBar } from './components/SessionStatus'
import { TradeSessionItemFooterProps } from './interface'

export const TradeSessionItemFooter = ({
  record,
  className
}: TradeSessionItemFooterProps) => {
  const { endTime, startTime, signUpStartTime, signUpEndTime } = record
  const statusInfo = useTradeSessionStatusInfo({
    endTime,
    startTime,
    signUpStartTime,
    signUpEndTime
  })

  const contentJustify =
    statusInfo.status === TradeSessionStatus.BID_END
      ? 'center'
      : 'space-between'

  let btnGroup: React.JSX.Element | null = null

  switch (statusInfo.status) {
    case TradeSessionStatus.WAIT_APPLY_START:
      break
    case TradeSessionStatus.APPLYING:
      btnGroup = <HomePriceCompareApplyButton record={record} />
      break
    case TradeSessionStatus.WAIT_BID_START:
      btnGroup = (
        <>
          <HomePriceCompareDetailButton record={record} />
          <HomeApplyAnnouncementDetailButton record={record} />
          <HomeAuctionDetailButton record={record} />
        </>
      )
      break
    case TradeSessionStatus.BIDDING:
      btnGroup = (
        <>
          <HomePriceCompareDetailButton record={record} />
          <HomeAuctionDetailButton record={record} />
        </>
      )
      break
    case TradeSessionStatus.BID_END:
      break
    default:
      break
  }

  return (
    <Flex align='center' className={className} justify={contentJustify}>
      <HomeTradeSessionStatusBar record={record} statusInfo={statusInfo} />
      {btnGroup}
    </Flex>
  )
}
